import api from './api';
import { User, ApiResponse } from '../types';

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export const authService = {
  register: (data: { name: string; email: string; phone?: string; password: string; referralCode?: string }) =>
    api.post<ApiResponse<{ userId: string }>>('/auth/register', data),

  login: (email: string, password: string) =>
    api.post<ApiResponse<LoginResponse>>('/auth/login', { email, password }),

  logout: () => api.post('/auth/logout'),

  refreshToken: (refreshToken: string) =>
    api.post<ApiResponse<{ accessToken: string; refreshToken: string }>>('/auth/refresh-token', { refreshToken }),

  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),

  resetPassword: (token: string, password: string) =>
    api.post('/auth/reset-password', { token, password }),

  verifyEmail: (token: string) =>
    api.get(`/auth/verify-email/${token}`),

  getMe: () => api.get<ApiResponse<User>>('/auth/me'),
};
